import { useEffect } from 'react';

interface UseClientSubscriptionsEffectsProps {
  error: unknown;
  showErrorHandler(error: unknown): void;
}

export const useClientSubscriptionsEffects = ({
  error,
  showErrorHandler,
}: UseClientSubscriptionsEffectsProps) => {
  useEffect(() => {
    if (error) showErrorHandler(error);
  }, [error, showErrorHandler]);
};
